import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Button, Modal, Row, Form } from 'react-bootstrap'
import InputText from '../../../components/commons/form/InputText'
import InputSelect from '../../../components/commons/form/InputSelect'
import InputDatePicker from '../../../components/commons/form/InputDatePicker'
import { permissions } from '../../../constants/backendIds'
import settings from '../../../setting'
import { getDateNowMaxDatePicker } from '../../../util/utils'
import { validateDate, validateMinimalStringLength } from '../../../util/validationFunctions'
import commonRegExp from '../../../util/commonRegExp'

class ReassingPurchaseModal extends Component {
  constructor () {
    super()
    this.state = {}
    this.required = this.required.bind(this)
    this.dateValidation = this.dateValidation.bind(this)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!this.props.showModal && nextProps.showModal) {
      const purchaseTypeCombo = this.props.combos?.purchaseTypeCombo || []
      let vehicle = {
        vinChassis: nextProps.vehicleOrderDetails.vinChassis || '',
        brandId: nextProps.vehicleOrderDetails.brandId || '',
        model: nextProps.vehicleOrderDetails.model || '',
        color: nextProps.vehicleOrderDetails.color || '',
        makerNumber: nextProps.vehicleOrderDetails.makerNumber || '',
        purchaseTypeId: nextProps.vehicleOrderDetails.purchaseTypeId || (purchaseTypeCombo.length === 1 ? purchaseTypeCombo[0].id : null),
        availabilityDate: nextProps.vehicleOrderDetails.availabilityDate || '',
        carlineId: nextProps.vehicleOrderDetails.carlineId || '',
        catalogueId: nextProps.vehicleOrderDetails.catalogueId || '',
        modelId: nextProps.vehicleOrderDetails.modelId || '',
        catalogueModelId: nextProps.vehicleOrderDetails.catalogueModelId || '',
        colorId: nextProps.vehicleOrderDetails.colorId || '',
        tapestryId: nextProps.vehicleOrderDetails.tapestryId || '',
        carline: nextProps.vehicleOrderDetails.carline || '',
        catalogue: nextProps.vehicleOrderDetails.catalogue || '',
        modelYear: nextProps.vehicleOrderDetails.modelYear || '',
        brandReference: nextProps.vehicleOrderDetails.brandReference || ''
      }
      this.props.initialize(vehicle)
    }
  }

  saveData (order) {
    this.props.actions.createOrderDossierPurchase(this.props.modalType, order)
    this.props.closeModal()
  }

  handleSubmitForm (values) {
    let order = {
      ...this.props.vehicleOrderDetails,
      dealerNumber: values.dealerNumber || '',
      vinChassis: values.vinChassis || '',
      brandId: values.brandId || '',
      model: values.model || '',
      color: values.color || '',
      makerNumber: values.makerNumber || '',
      purchaseTypeId: values.purchaseTypeId || '',
      availabilityDate: values.availabilityDate || '',
      carlineId: values.carlineId || '',
      catalogueId: values.catalogueId || '',
      modelId: values.modelId || '',
      catalogueModelId: values.catalogueModelId || '',
      colorId: values.colorId || '',
      tapestryId: values.tapestryId || '',
      carline: values.carline || '',
      catalogue: values.catalogue || '',
      modelYear: values.modelYear || '',
      brandReference: values.brandReference || ''
    }
    this.saveData(order)
  }

  dateValidation (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  required (value) {
    if (!value) {
      return this.props.t('GLOBAL.FORMS.REQUIRED')
    } else {
      return undefined
    }
  }

  onBrandIdChanges (brandId) {
    this.props.actions.resetCarlineCombo()
    this.props.actions.resetCatalogueCombo()
    this.props.actions.resetColorCombo()
    this.props.actions.resetTapestryCombo()
    if (brandId) {
      this.props.actions.fetchCarlineCombo(brandId)
    }
  }

  onCarlineIdChanges (carlineId) {
    this.props.actions.resetColorCombo()
    this.props.actions.resetTapestryCombo()
    if (carlineId) {
      this.props.actions.fetchCatalogueCombo(carlineId)
    }
  }

  onCatalogueIdChanges (catalogueId) {
    if (this.props.formValues.modelId && catalogueId) {
      this.props.actions.fetchReassignPurchaseCatalogueModel(catalogueId, this.props.formValues.modelId)
      this.props.actions.fetchColorCombo(catalogueId, this.props.formValues.modelId)
      this.props.actions.fetchTapestryCombo(catalogueId, this.props.formValues.modelId)
    }
  }

  onModelIdChanges (modelId) {
    if (modelId && this.props.formValues.catalogueId) {
      this.props.actions.fetchReassignPurchaseCatalogueModel(this.props.formValues.catalogueId, modelId)
      this.props.actions.fetchColorCombo(this.props.formValues.catalogueId, modelId)
      this.props.actions.fetchTapestryCombo(this.props.formValues.catalogueId, modelId)
    }
  }

  render () {
    const {
      t, handleSubmit, showModal, closeModal, actions: { synchroniseAvailabilityDate },
      combos: { brandCombo, purchaseTypeCombo, carlineCombo, catalogueCombo, modelCombo, colorCombo, tapestryCombo }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.REASSING_PURCHASE_MODAL.'
    const purchaseTypeComboSaleable = purchaseTypeCombo.filter(x => x.isNotSaleable === false)

    return (
      <Modal id='ReassingPurchaseModal' className="_nf" show={showModal} onHide={closeModal}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.handleSubmitForm.bind(this))}>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className='fieldsContainer flexRow'>
              {this.props.mandatoryFields.purchaseTypeId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="purchaseTypeId"
                  name="purchaseTypeId"
                  colSm={6}
                  controlLabel={t(`${tKey}PURCHASE_TYPE_ID`)}
                  placeholder={t(`${tKey}PURCHASE_TYPE_ID`)}
                  options={purchaseTypeComboSaleable}
                  labelKey="value"
                  valueKey="id"
                  onInputChange={purchaseTypeId => this.setState({ purchaseTypeId })}
                  validate={[this.required]}
                />
              )}
              {this.props.mandatoryFields.availabilityDate.permission !== permissions.hidden && (
                <Field
                  component={InputDatePicker}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  maxDate={getDateNowMaxDatePicker()}
                  id="availabilityDate"
                  name="availabilityDate"
                  controlLabel={t(`${tKey}AVAILABILITY_DATE`)}
                  onBlur={availabilityDate => this.setState({ availabilityDate })}
                  validate={[this.dateValidation]}
                  onInputChange={synchroniseAvailabilityDate}
                />
              )}
              {this.props.mandatoryFields.makerNumber.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  name="makerNumber"
                  id="reassingMakerNumber"

                  controlLabel={t(`${tKey}MAKER_NUMBER`)}
                  onBlur={makerNumber => this.setState({ makerNumber })}
                />
              )}
              {this.props.mandatoryFields.vsb.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  name="dealerNumber"
                  id="dealerNumber"
                  controlLabel={t(`${tKey}DEALER_NUMBER`)}
                  onBlur={dealerNumber => this.setState({ dealerNumber })}
                  maxLength={settings.dealerMaxLength}
                />
              )}
              {this.props.mandatoryFields.brand.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  name="brandId"
                  controlLabel={t(`${tKey}BRAND`)}
                  placeholder={t(`${tKey}BRAND`)}
                  options={brandCombo}
                  labelKey="value"
                  valueKey="id"
                  onInputChange={this.onBrandIdChanges.bind(this)}
                />
              )}
              {this.props.mandatoryFields.carlineId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="carlineId"
                  name="carlineId"
                  controlLabel={t(`${tKey}CARLINE`)}
                  placeholder={t(`${tKey}CARLINE`)}
                  valueKey="id"
                  labelKey="value"
                  options={carlineCombo}
                  disabled={carlineCombo.length === 0 || this.props.mandatoryFields.carlineId.permission !== permissions.editable}
                  onInputChange={this.onCarlineIdChanges.bind(this)}
                  menuPlacement="auto"
                />
              )}
              {this.props.mandatoryFields.carline.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="carline"
                  name="carline"
                  controlLabel={t(`${tKey}CARLINE`)}
                  placeholder={t(`${tKey}CARLINE`)}
                  disabled={ this.props.mandatoryFields.carline.permission !== permissions.editable}
                />
              )}
              {this.props.mandatoryFields.catalogueId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="catalogueId"
                  name="catalogueId"
                  controlLabel={t(`${tKey}CATALOGUE`)}
                  placeholder={t(`${tKey}CATALOGUE`)}
                  valueKey="id"
                  labelKey="value"
                  options={catalogueCombo}
                  disabled={catalogueCombo.length === 0 || this.props.mandatoryFields.catalogueId.permission !== permissions.editable}
                  onInputChange={this.onCatalogueIdChanges.bind(this)}
                  menuPlacement="auto"
                />
              )}
              {this.props.mandatoryFields.catalogue.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="catalogue"
                  name="catalogue"
                  controlLabel={t(`${tKey}CATALOGUE`)}
                  placeholder={t(`${tKey}CATALOGUE`)}
                  disabled={ this.props.mandatoryFields.catalogue.permission !== permissions.editable}
                />
              )}
              {this.props.mandatoryFields.modelId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="modelId"
                  name="modelId"
                  controlLabel={t(`${tKey}MODEL_YEAR`)}
                  placeholder={t(`${tKey}MODEL_YEAR`)}
                  valueKey="id"
                  labelKey="value"
                  options={modelCombo}
                  disabled={modelCombo.length === 0 || this.props.mandatoryFields.modelId.permission !== permissions.editable}
                  onInputChange={this.onModelIdChanges.bind(this)}
                  menuPlacement="auto"

                />
              )}
              {this.props.mandatoryFields.modelYear.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="modelYear"
                  name="modelYear"
                  controlLabel={t(`${tKey}MODEL_YEAR`)}
                  placeholder={t(`${tKey}MODEL_YEAR`)}
                  disabled={ this.props.mandatoryFields.modelYear.permission !== permissions.editable}
                />
              )}
              {this.props.mandatoryFields.model.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="model"
                  name="model"
                  controlLabel={t(`${tKey}MODEL`)}
                  placeholder={t(`${tKey}MODEL`)}
                  disabled={this.props.mandatoryFields.model.permission !== permissions.editable}
                />
              )}
              {this.props.mandatoryFields.colorId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="colorId"
                  name="colorId"
                  controlLabel={t(`${tKey}COLOR`)}
                  placeholder={t(`${tKey}COLOR`)}
                  valueKey="id"
                  labelKey="value" options={colorCombo}
                  disabled={colorCombo.length === 0 || this.props.mandatoryFields.colorId.permission !== permissions.editable}
                />
              )}
              {this.props.mandatoryFields.tapestryId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="tapestryId"
                  name="tapestryId"
                  controlLabel={t(`${tKey}TAPESTRY`)}
                  placeholder={t(`${tKey}TAPESTRY`)}
                  valueKey="id"
                  labelKey="value"
                  options={tapestryCombo}
                  disabled={tapestryCombo.length === 0 || this.props.mandatoryFields.tapestryId.permission !== permissions.editable}
                />
              )}
              {this.props.mandatoryFields.color.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="color"
                  name="color"
                  controlLabel={t(`${tKey}COLOR`)}
                  placeholder={t(`${tKey}COLOR`)}
                  disabled={this.props.mandatoryFields.colorId.permission !== permissions.editable}
                />
              )}
              {this.props.mandatoryFields.tapestry.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="tapestry"
                  name="tapestry"
                  controlLabel={t(`${tKey}TAPESTRY`)}
                  placeholder={t(`${tKey}TAPESTRY`)}
                  disabled={this.props.mandatoryFields.tapestry.permission !== permissions.editable}
                />
              )}
              {this.props.mandatoryFields.brandReference.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  colWidth={50}
                  id="brandReference"
                  name="brandReference"
                  controlLabel={t(`${tKey}BRAND_REFERENCE`)}
                  placeholder={t(`${tKey}BRAND_REFERENCE`)}
                  disabled={this.props.mandatoryFields.brandReference.permission !== permissions.editable}
                  maxLength={20}
                />
              )}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div sm={12} className="flexInLine al-C">
              <Button id="btn_save" className="_Btn accept" type="submit">{t(`${tKey}CREATE_BUTTON`)}</Button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'reassingPurchaseModal',
  validate: (values, props) => {
    const error = {}

    if (props.mandatoryFields.makerNumber.permission && props.mandatoryFields.makerNumber.permission !== permissions.hidden && !values.makerNumber &&
        props.mandatoryFields.vsb.permission && props.mandatoryFields.vsb.permission !== permissions.hidden && ((!values.dealerNumber || values.dealerNumber.lenght === 0))) {
      error.makerNumber = props.t('DOSSIER_COMPONENTS.REASSING_PURCHASE_MODAL.VALIDATION')
      error.dealerNumber = props.t('DOSSIER_COMPONENTS.REASSING_PURCHASE_MODAL.VALIDATION')
    }
    if (props.mandatoryFields.brand.permission && props.mandatoryFields.brand.permission !== permissions.hidden && (!values.brandId || values.brandId.lenght === 0)) {
      error.brandId = props.t('DOSSIER_COMPONENTS.REASSING_PURCHASE_MODAL.VALIDATION')
    }
    if (values.dealerNumber && values.dealerNumber !== '' && settings.dealerNumberRegex) {
      if (!values.dealerNumber.match(settings.dealerNumberRegex)) {
        error.dealerNumber = props.t('GLOBAL.FORMS.INVALID_STRING')
      }
    }

    if (props.mandatoryFields.modelId.permission &&
      props.mandatoryFields.modelId.permission !== permissions.hidden &&
      (!values.modelId || values.modelId.lenght === 0)) {
      error.modelId = props.t('DOSSIER_COMPONENTS.REASSING_PURCHASE_MODAL.VALIDATION')
    }

    if (props.mandatoryFields.modelYear.permission &&
      props.mandatoryFields.modelYear.permission !== permissions.hidden &&
      (!values.modelYear || !values.modelYear.match(commonRegExp.is4DigitYear))) {
      error.modelYear = props.t('GLOBAL.FORMS.INVALID_STRING')
    }

    if (values.brandReference && values.brandReference.length < 4) {
      error.brandReference = validateMinimalStringLength(props.t, values.brandReference, 4)
    }

    return error
  }
})(ReassingPurchaseModal)
